module.exports = __webpack_public_path__ + "img/logo.d320598e.svg";